const { format } = require('date-fns')
const { Entity } = require('./entity')
const { createLines } = require('./lines')
const { getTax } = require('./tax')

class Invoice extends Entity {
  constructor (quickbooks, query) {
    super(quickbooks, 'Invoice')
    this.query = query
  }

  /**
   * @param {string[]} invoiceIds
   * @param {string} companyCode
   */
  getList (invoiceIds, companyCode) {
    if (!invoiceIds || !invoiceIds.length) {
      return []
    }

    return this.query.send({
      companyCode,
      type: 'Invoice',
      where: `Id in (${[...invoiceIds].map(id => `'${id}'`).join(',')})`,
      maxResults: 250
    })
  }

  async create ({
    invoice: {
      docNumber,
      vatRate,
      email,
      companyCode,
      customerId,
      dueDate = null,
      txnDate = null,
      customField = '',
      customerMemo
    },
    lines,
    hasCustomVatLine = false,
    discountAmount = 0
  }) {
    const qboLines = await createLines({
      quickbooks: this.quickbooks,
      companyCode,
      lines,
      hasCustomVatLine,
      vatRate,
      discountAmount
    })

    const qboInvoice = {
      CustomField: [{
        DefinitionId: '1',
        StringValue: customField,
        Name: 'OrderType',
        Type: 'StringType'
      }],
      CustomerRef: {
        value: customerId
      },
      DocNumber: docNumber,
      BillEmail: {
        Address: email
      },
      Line: qboLines
    }
    if (dueDate) {
      qboInvoice.DueDate = format(dueDate, 'YYYY-MM-DD')
    }
    if (txnDate) {
      qboInvoice.TxnDate = format(txnDate, 'YYYY-MM-DD')
    }

    if (customerMemo) {
      qboInvoice.CustomerMemo = { value: customerMemo }
    }

    if (!hasCustomVatLine) {
      const qboTax = await getTax({
        quickbooksInterface: this.quickbooks.quickbooksInterface,
        companyCode
      })
      qboInvoice.TxnTaxDetail = {
        TxnTaxCodeRef: {
          value: qboTax.codeId
        },
        TaxLine: [
          {
            DetailType: 'TaxLineDetail',
            TaxLineDetail: {
              TaxRateRef: {
                value: qboTax.rateId
              }
            }
          }
        ]
      }
    }

    if (qboLines.length === 0) {
      return null
    }

    const { Invoice: createdInvoice } = await this.quickbooks.quickbooksInterface.post(
      companyCode,
      `invoice?minorversion=${this.quickbooks.quickbooksInterface.apiVersion}`,
      qboInvoice
    )
    return createdInvoice
  }

  async sendEmail ({
    companyCode,
    invoice,
    ccEmails
  }) {
    let billEmailBcc = this.quickbooks.quickbooksInterface.billEmailBcc[companyCode]
    const payload = {
      SyncToken: invoice.SyncToken,
      DeliveryAddress: {
        Address: invoice.BillEmail.Address
      }
    }
    if (billEmailBcc) {
      if (ccEmails && ccEmails.length) {
        ccEmails.push(billEmailBcc)
        billEmailBcc = ccEmails.toString()
      }
      payload.DeliveryAddressBcc = {
        Address: billEmailBcc
      }
    }
    const url = `invoice/${invoice.Id}/send?minorversion=${this.quickbooks.quickbooksInterface.apiVersion}`
    return this.quickbooks.quickbooksInterface.post(companyCode, url, payload)
  }

  downloadPdf ({ txnId, companyCode }) {
    const url = `invoice/${txnId}/pdf`
    return this.quickbooks.quickbooksInterface.get(
      companyCode,
      url,
      {
        'Accept': 'application/pdf',
        'content-type': 'application/pdf'
      }
    )
  }
}

module.exports = {
  Invoice
}
